<template>
  <div class="d-flex">
    <div class="align-self-center">
      <b-form class="login row" @submit.prevent="handleSubmit">
        <div class="col-md-3"></div>
        <div class="col-md-6 formLogin">
          <img
            id="imgLogin"
            class="mx-auto d-block img-fluid"
            :src="'/img/' + this.partner.code + '/logo_blanc.png'"
          />
          <div class="pt-3 text-center" v-if="initLoading">
            <b-spinner class="align-middle"></b-spinner>
          </div>
          <div class="pt-5" v-else-if="invalidToken">
            <p>
              Votre lien est arrivé à expiration. Veuillez renouveler votre
              demande.
            </p>
            <br />
            <b-button
              type="button"
              @click="resetmdp"
              class="btn btn-block btn-outline-gold mt-3 mb-3 border-2 bold"
              ><span v-if="loading">Demande en cours ...</span
              ><span v-if="!loading"
                >Recevoir mon lien de réinitialisation</span
              ></b-button
            >
            <br />
          </div>
          <div class="pt-5" v-else>
            <h3>Nouveau mot de passe</h3>
            <b-form-group
              id="password-group"
              label="Mot de passe"
              label-for="password"
            >
              <b-form-input
                id="password"
                v-model="datas.password1"
                :type="viewPassword ? 'text' : 'password'"
                required
                placeholder="Mot de passe"
                :disabled="loading"
              ></b-form-input>
              <span
                class="material-icons"
                @click="viewPassword = !viewPassword"
                style="position:absolute;top:5px;right:5px;cursor:pointer"
                >visibility{{ viewPassword ? "_off" : "" }}</span
              >
              <small
                v-if="rules.uppercase"
                :class="
                  'passwordTest form-text text-muted ' +
                    (datas.password1 == '' || checkPass() ? '' : 'b')
                "
                >Le mot de passe doit contenir :
                <span class="text-black">
                  Le mot de passe ne doit pas contenir de mots évidents comme
                  votre nom, prénom, nom de votre entreprise, ou du site.
                </span>
                <span class="text-black">
                  Le mot de passe ne peut pas être un mot de passe déjà utilisé
                  par le passé.
                </span>
                <span
                  :class="
                    datas.password1.length >= rules.min_length
                      ? 'has_required'
                      : ''
                  "
                  >au moins {{ rules.min_length }} caractères</span
                >
                <span
                  :class="
                    datas.password1.length <= rules.max_length
                      ? 'has_required'
                      : ''
                  "
                  >au plus {{ rules.max_length }} caractères</span
                >
                <span
                  :class="
                    rules.uppercase.test(datas.password1) ? 'has_required' : ''
                  "
                  >au moins une majuscule</span
                >
                <span
                  :class="
                    rules.lowercase.test(datas.password1) ? 'has_required' : ''
                  "
                  >au moins une minuscule</span
                >
                <span
                  :class="
                    rules.number.test(datas.password1) ? 'has_required' : ''
                  "
                  >au moins un chiffre</span
                >
                <span
                  :class="
                    rules.special_chars.test(datas.password1)
                      ? 'has_required'
                      : ''
                  "
                  >au moins un caractère spécial</span
                >
              </small>
            </b-form-group>
            <b-form-group
              id="password2-group"
              label="Confirmation"
              label-for="password2"
            >
              <b-form-input
                id="password2"
                v-model="datas.password2"
                :type="viewPassword ? 'text' : 'password'"
                required
                placeholder="Mot de passe"
                :disabled="loading"
              ></b-form-input>
              <span
                class="material-icons"
                @click="viewPassword = !viewPassword"
                style="position:absolute;top:5px;right:5px;cursor:pointer"
                >visibility{{ viewPassword ? "_off" : "" }}</span
              >
              <small
                v-if="rules.uppercase"
                :class="
                  'passwordTest form-text text-muted ' +
                    (datas.password2 == '' || checkPass() ? '' : 'b')
                "
              >
                <span
                  :class="
                    datas.password1 == datas.password2 ? 'has_required' : ''
                  "
                  >les mots de passe doivent être identiques</span
                >
              </small>
            </b-form-group>
            <br />
            <b-button
              type="submit"
              class="btn btn-block btn-outline-gold mt-3 mb-3 border-2 bold"
              ><span v-if="connexion">Enregistrement en cours ...</span
              ><span v-if="!connexion">Valider</span></b-button
            >
          </div>
        </div>
        <div class="col-md-3"></div>
      </b-form>
    </div>
    <b-modal
      id="modal-mdp"
      title="Votre demande de réinitialisation"
      hide-footer
    >
      <p class="my-4">{{ modalError }}</p>
      <b-button
        type="button"
        @click="resetmdp"
        class="btn btn-block btn-outline-gold mt-3 mb-3 border-2 bold"
        ><span v-if="loading">Demande en cours ...</span
        ><span v-if="!loading"
          >Recevoir par email un nouveau lien d’initialisation</span
        ></b-button
      >
    </b-modal>
    <b-modal
      id="modal-mdp-ok"
      title="Votre demande de réinitialisation"
      hide-footer
    >
      <p class="my-4">
        Si votre compte existe est actif, la demande est envoyée et vous allez
        recevoir un mail.
      </p>
      <b-button
        type="button"
        @click="closemdp"
        class="btn btn-block btn-outline-gold mt-3 mb-3 border-2 bold"
        >Fermer</b-button
      >
    </b-modal>
    <!--<p class="cookies_bar" v-if="cb_accepted===false">Ce site utilise des cookies, petits fichiers enregistrés sur votre terminal lors de votre visite sur le site. Vous pouvez accepter ou refuser leur dépôt. En poursuivant votre visite, vous acceptez l'utilisation de cookies pour mesurer notre audience, vous proposer des contenus et fonctionnalités personnalisés. <a href="javascript:void(0)" @click="cb_accept" class="btn btn-default btn-sm">Oui, j'accepte</a> <a :href="this.partner.cookies_url" target="_blank" class="btn btn-default btn-sm">En savoir plus</a>  </p>-->
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      type: "",
      viewPassword: false,
      modalError: "",
      datas: {
        username: "",
        password1: "",
        password2: "",
        token: "",
      },
      rules: {
        min_length: 8,
        max_length: 16,
        special_chars: /[\@\[\]^?_!"#$%&'()*+,\-./:;{}<>=|~]/,
        lowercase: /[a-z]/,
        uppercase: /[A-Z]/,
        number: /[0-9]/,
      },
      connexion: false,
      loading: false,
      initLoading: true,
      invalidToken: false,
    };
  },
  created() {
    var p = this;
    axios.get(this.$apiUrl + "user/getPassRules").then(function(response) {
      p.rules.min_length = response.data.min_length;
      p.rules.max_length = response.data.max_length;
      p.rules.special_chars = new RegExp(response.data.special_chars);
      p.rules.lowercase = new RegExp(response.data.lowercase);
      p.rules.uppercase = new RegExp(response.data.uppercase);
      p.rules.number = new RegExp(response.data.number);
    });
  },
  mounted() {
    this.get_partner(this.$route);
    this.type = this.$route.params.type;
    this.datas.username = this.$route.params.username;
    this.datas.token = this.$route.params.token;
    this.checkToken();
  },
  methods: {
    resetmdp() {
      var p = this;
      if (p.loading) return false;
      p.loading = true;
      let formData = new FormData();
      formData.append("username", p.datas.username);
      formData.append("host", window.location.hostname);
      axios
        .post(this.$apiUrl + "user/passReset/" + p.datas.username, formData, {
          headers: {
            "Content-Type":
              "multipart/form-data; charset=utf-8; boundary=" +
              Math.random()
                .toString()
                .substr(2),
          },
        })
        .then(function(response) {
          p.loading = false;
          if (response.data.error) {
            p.show_alert("warning", response.data.error.join(", "));
          } else {
            p.$bvModal.show("modal-mdp-ok");
          }
        });
    },
    closemdp() {
      this.$bvModal.hide("modal-mdp-ok");
    },
    checkPass() {
      return (
        this.datas.password1.length >= this.rules.min_length &&
        this.datas.password1.length <= this.rules.max_length &&
        this.rules.uppercase.test(this.datas.password1) &&
        this.rules.lowercase.test(this.datas.password1) &&
        this.rules.number.test(this.datas.password1) &&
        this.rules.special_chars.test(this.datas.password1) &&
        this.datas.password2 == this.datas.password1
      );
    },
    checkToken() {
      var p = this;
      axios
        .post(this.$apiUrl + "user/checkToken/" + p.datas.token)
        .then(function(response) {
          p.initLoading = false;
          if (response.data.error) {
            p.invalidToken = true;
          } else {
            p.invalidToken = false;
          }
        });
    },
    handleSubmit(e) {
      var p = this;
      if (this.checkPass()) {
        p.loading = true;
        let formData = new FormData();
        formData.append("datas", JSON.stringify(p.datas));
        formData.append("host", window.location.hostname);
        this.connexion = true;
        axios
          .post(this.$apiUrl + "user/passAction/" + p.type, formData, {
            headers: {
              "Content-Type":
                "multipart/form-data; charset=utf-8; boundary=" +
                Math.random()
                  .toString()
                  .substr(2),
            },
          })
          .then(function(response) {
            if (response.data.error) {
              p.modalError = response.data.error.join(" ");
              p.$bvModal.show("modal-mdp");
            } else {
              p.show_alert("success", "Mot de passe modifié avec succés");
              p.loading = true;
              let formData = new FormData();
              formData.append("username", p.datas.username);
              formData.append("password", p.datas.password1);
              formData.append("host", window.location.hostname);
              p.connexion = true;
              axios
                .post(p.$apiUrl + "login", formData, {
                  headers: {
                    "Content-Type":
                      "multipart/form-data; charset=utf-8; boundary=" +
                      Math.random()
                        .toString()
                        .substr(2),
                  },
                })
                .then(function(response) {
                  if (response.data.error) {
                    p.modalError = response.data.error;
                    p.$bvModal.show("modal-mdp");
                  } else {
                    if (response.data.datas && response.data.count > 0) {
                      var user = response.data.datas;
                      p.set_current_user(user);
                      p.$router.push("/").catch((error) => {});
                      p.get_infos_cli();
                    } else {
                      p.infosModal("warning", response.data.error);
                    }
                  }
                  p.connexion = false;
                  p.loading = false;
                })
                .catch(function(error) {
                  p.show_alert(
                    "warning",
                    "Le service api-fw.ooftop.fr n'est pas accessible."
                  );
                  p.connexion = false;
                  p.loading = false;
                });
            }
            p.connexion = false;
            p.loading = false;
          })
          .catch(function(error) {
            p.show_alert(
              "warning",
              "Le service api-fw.ooftop.fr n'est pas accessible."
            );
            p.connexion = false;
            p.loading = false;
          });
      }
    },
  },
};
</script>
<style scoped>
.passwordTest {
  display: none;
}
.passwordTest.b {
  display: block;
}
.passwordTest > span {
  display: block;
}
.passwordTest.b > span {
  color: red;
}
.passwordTest.b > span.has_required {
  color: green;
}
.passwordTest.b > span.text-black {
  color: black;
}
</style>
